(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('EventsInternalController', EventsInternalController);

    /** @ngInject */
    function EventsInternalController($scope, $state, $stateParams, $rootScope, EventService, AuthenticationService, HelperService, DATA_EVENTS) {
        const vm = this;

        vm.getEventImage = () => {
            return HelperService.imageResizePath('event', vm.event.Id, vm.event.Image, 800, 400);
        }

        vm.printDiv = function (divName) {
            var printContents = document.getElementById(divName).innerHTML;

            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
                var popupWin = window.open('', '_blank', 'width=600,height=600,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
                popupWin.window.focus();
                popupWin.document.write('<!DOCTYPE html><html><head>' +
                    '<link rel="stylesheet" href="/app/dist/styles/style.min.css?t=1553274462071" />' +
                    '</head><body onload="window.print()">' + printContents + '</body></html>');
                popupWin.onbeforeunload = function (event) {
                    popupWin.close();
                    return '.\n';
                };
                popupWin.onabort = function (event) {
                    popupWin.document.close();
                    popupWin.close();
                }
            } else {
                var popupWin = window.open('', '_blank', 'width=800,height=600');
                popupWin.document.open();
                popupWin.document.write('<html><head><link rel="stylesheet" href="/app/dist/styles/style.min.css?t=1553274462071" /></head><body onload="window.print()">' + printContents + '</body></html>');
                popupWin.document.close();
            }

            popupWin.document.close();

            return true;
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function recordPersonVisualization() {
            if (vm.event.HasPersonRead) return;

            let userData = AuthenticationService.getUserData();
            let accessLogData = {
                EventId: vm.event.Id,
                PersonId: userData.Id
            }

            EventService
                .postAccessLog(accessLogData);
        }

        function getEvent() {
            HelperService.startLoading('.events-internal');

            let userData = AuthenticationService.getUserData();

            EventService
                .getByUrl($stateParams.eventUrl, userData.Id, userData.Responsibility.Id)
                .then(success => {
                    vm.event = success;

                    recordPersonVisualization();

                    HelperService.stopLoading('.events-internal');
                }, error => {
                    HelperService.errorCallback(error);
                    $state.go('app-master.default.events');
                })
        }

        function initVars() {
            vm.comments = [];
            vm.isLoadingComments = true;
        }

        function init() {
            initVars();
            getEvent();
        }
    }
}());